export default __webpack_public_path__ + "static/media/payment-failure.21ac103f.jpeg";